module.exports = __webpack_public_path__ + "img/info.1a796691.svg";